import { render, staticRenderFns } from "./fj_details.vue?vue&type=template&id=604bdaaa&scoped=true&"
import script from "./fj_details.vue?vue&type=script&lang=js&"
export * from "./fj_details.vue?vue&type=script&lang=js&"
import style0 from "./fj_details.vue?vue&type=style&index=0&id=604bdaaa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604bdaaa",
  null
  
)

export default component.exports